<template>
  <div class="question-table-container">
    <CCard class="question-list-table-card">
      <CDataTable :items="items" :fields="fields" fixed hover striped bordered>
        <template #title="{item}">
          <td>
            {{ item.title | truncate(30) }}
          </td>
        </template>
        <template #created_at="{item}">
          <td>{{ item.created_at | moment(dateFormat) }}</td>
        </template>
        <template #category_type="{item}">
          <td>
            <StakingBadge type="question-cat" :text="item.category_type" />
          </td>
        </template>

        <template #question_type="{item}">
          <td>
            <StakingBadge type="question-type" :text="item.question_type" />
          </td>
        </template>
        <template #actived_flg="{item}">
          <td>
            <CIcon v-if="item.actived_flg" class="fixed-rate-icon" name="cil-check" />
          </td>
        </template>
        <template #action="{item}">
          <td class="buttons" width="120px">
            <button class="btn btn-view-details" @click="viewDetails(item)">
              <img src="@/assets/images/ico-edit-user.svg" alt class="hand edit-icon" />
            </button>
            <CButton @click="openModal(item)" v-if="isAllowedDel && item.title">
              <img src="@/assets/images/ico-del-user.svg" alt class="hand edit-icon" />
            </CButton>
          </td>
        </template>
      </CDataTable>
    </CCard>
    <CModal id="deleteModal" :show.sync="warningModal" :centered="true">
      <template #header>
        <CButtonClose @click="warningModal = false" />
      </template>
      <div class>
        <div class="pb-4 tit-dele">
          <p>{{ $t('QUESTION_LIST_TABLE_COMPONENT_MODAL_TITLE') }}</p>
        </div>
        <div class="text-modal" v-html="$t('QUESTION_LIST_TABLE_COMPONENT_MODAL_CONTENT')"></div>
      </div>
      <template #footer>
        <CButton class="cancel-btn" @click="warningModal = false" color="dark" variant="outline">{{
          $t('QUESTION_LIST_TABLE_COMPONENT_MODAL_BUTTON_CANCEL')
        }}</CButton>
        <CButton @click="del(id)" class="delete-btn">{{ $t('QUESTION_LIST_TABLE_COMPONENT_MODAL_BUTTON_DELETE') }}</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import StakingBadge from '@/components/StakingBadge';
import { Constants } from '@/constants';
import responseHelper from '@/utils/response-helper';
import endpoints from '@/constants/endpoints';

export default {
  name: 'QuestionListTable',
  components: {
    StakingBadge,
  },
  data() {
    return {
      dateFormat: Constants.dateFormat,
      fields: [
        {
          key: 'title',
          label: this.$t('QUESTION_LIST_TABLE_COMPONENT_TITLE_COL'),
          _style: 'min-width: 80px; text-align: left;',
        },
        {
          key: 'category_type',
          label: this.$t('QUESTION_LIST_TABLE_COMPONENT_CATEGORY_COL'),
        },
        {
          key: 'question_type',
          label: this.$t('QUESTION_LIST_TABLE_COMPONENT_TYPE_COL'),
          _style: 'min-width: 80px; text-align: left;',
        },
        {
          key: 'points',
          label: this.$t('QUESTION_LIST_TABLE_COMPONENT_POINTS_COL'),
        },
        {
          key: 'actived_flg',
          label: this.$t('QUESTION_LIST_TABLE_COMPONENT_ACTIVE_COL'),
        },
        {
          key: 'created_at',
          label: this.$t('QUESTION_LIST_TABLE_COMPONENT_CREATE_AT_COL'),
        },
        {
          key: 'action',
          label: '',
        },
      ],
      warningModal: false,
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    activePage: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 0,
    },
    isAllowedDel: {
      type: Boolean,
      default: false,
    },
    getQuestions: {
      type: Function,
      default: null,
    },
  },
  methods: {
    viewDetails(item) {
      this.$router.push(`questions/${item.id}/details`);
    },
    async del(id) {
      try {
        await this.$http.delete(endpoints.deleteQuestions(id));
        this.$notify({
          group: 'notifications',
          type: 'success',
          title: this.$t('QUESTION_LIST_TABLE_COMPONENT_DELETE_NOTIFY_TITLE_SUCCESSFUL'),
          text: this.$t('QUESTION_LIST_TABLE_COMPONENT_DELETE_SUCCESSFUL'),
        });
        this.warningModal = false;
        this.getQuestions();
      } catch (err) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: this.$t('QUESTION_LIST_TABLE_COMPONENT_NOTIFY_TITLE_ERROR'),
          text: responseHelper.getErrorMessage(err),
        });
      }
    },
    openModal(value) {
      this.id = value.id;
      this.warningModal = true;
    },
  },
};
</script>

<style lang="scss">
.question-table-container {
  .question-list-table-card {
    .table {
      margin-bottom: 0;
      .hand {
        cursor: pointer;
      }
      .btn {
        font-size: 14px;
        font-weight: 400;
        color: #0505a5;
        outline: none;
        padding-top: 0;
        padding-bottom: 0;
      }

      .question-image {
        width: 30px;
      }

      .fixed-rate-icon {
        color: #5da30b;
      }
      .question-type,
      .question-cat,
      .question-actived_flg {
        border: none;
        padding: 5px 0px;
        background-color: transparent;
      }
    }
  }
  .modal-body {
    padding: 1.3rem 1.5rem;
    .tit-dele {
      p {
        font-size: 18px;
      }
    }
  }

  .modal-content {
    width: 85%;
    .modal-header {
      border: none;
      padding: 0 8px;
      display: none;
    }
    .text-modal {
      strong {
        color: #3a4a7f;
        font-weight: 500;
      }
    }
    .modal-footer {
      border: none;
      justify-content: center;
      .delete-btn {
        background-color: #ff5555;
        color: #ffffff;
        width: 150px;
        font-weight: 500;
        font-size: 14px;
        margin: 0 10px;
      }
      .cancel-btn {
        width: 150px;
        border: 2px solid #cbcbcb;
        color: #657187;
        font-weight: 500;
        font-size: 14px;
        margin: 0 10px;
        &:hover {
          background-color: #fff;
        }
      }
    }
  }
}
</style>

